import { defPageSize } from "../../constants/events";
import { z } from "zod";

export const clientFiltersCacheKey = "CLIENT_FILTERS_CACHE_KEY";

export interface CustomerListFilters {
  user_id?: number;
  source_id?: number;
  group_id?: number;
  searchQuery?: string;
  search_in_subgroup?: boolean;
  date_created_min?: string;
  date_created_max?: string;
  order_dir?: "ASC" | "DESC" | "RELATIVE";
  search_query?: string;
  offset?: number;
  limit?: number;
}

export const CustomerListRequestParamsSchema = z.object({
    user_id: z.number().optional(),
    group_id: z.number().optional(),
    source_id: z.number().optional(),
    search_in_subgroup: z.boolean().optional(),
    date_create_min: z.string().optional(),
    date_create_max: z.string().optional(),
    search_query: z.string().optional(),
    order_dir: z.enum(["ASC", "DESC"]).optional().default("ASC"),
    offset: z.number().default(0),
    limit: z.number().default(defPageSize),
  });

export const defaultCustomerFilters: CustomerListFilters = {
    order_dir: "DESC",
    offset: 0,
    limit: defPageSize,
    search_in_subgroup: true
}
